/** This is a generic find function where the object's values can be typed as any */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function find(key: string, obj: { [key: string]: any }): object | null {
  let result = null;
  for (const k in obj) {
    if (k === key) {
      result = obj[k]
    } else if (typeof obj[k] === 'object' && obj[k] !== null) {
      const value = find(key, obj[k]);
      if (value !== undefined && value !== null) {
        result = value
      }
    }
  }
  return result;
}

export { find };
